import { useState } from "react";
import { Col, Collapse, Row } from "reactstrap";
import { SharedDocumentTitle } from "../../../../Constants/Constants";
import { SharedDocumentData } from "../../../../Data/Bonus/Elements";
import SharedMedia from "./SharedMedia";

const SharedDocument = () => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <section className="massage_box">
      <Row>
        <Col md="6" sm="12">
          <div className="element-card">
            <div className="element-card-header heading">
              <h2>{SharedDocumentTitle}</h2>
            </div>
            <div className="element-card-body typography">
              <div className="document">
                <div className="filter-block">
                  <div className="collapse-block open">
                    <h5 className="block-title" onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: "1rem" }}>{SharedDocumentTitle}</h5>
                    <Collapse className="block-content" isOpen={isOpen}>
                      <ul className="document-list">
                        {SharedDocumentData.map((item, index) => (
                          <li key={index}>
                            <i className={`ti-${item.icon}`} />
                            <h5>{item.text}</h5>
                          </li>
                        ))}
                      </ul>
                    </Collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <SharedMedia />
      </Row>
    </section>
  );
};

export default SharedDocument;
